import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { HttpError } from "./httpError.interface";
import { NOTIFICATION_CATALOG } from "../../notification/notification.catalog";
import type { NotificationDefinition, NotificationRequest } from "../../notification/notification.model";

@Injectable({ providedIn: "root" })
export class ResponseErrorHandlerService {
    timersValue = {
        successfullySaved: 3 * 1000,
        cannotSaveChanges: 10 * 1000,
        CancelSaved: 5 * 1000,
        Default: 5 * 1000,
        deviceTrusted: 3 * 1000,
    };

    private readonly showNotificationEmitter = new Subject<NotificationDefinition>();
    readonly showNotificationEvent$ = this.showNotificationEmitter.asObservable();
    showBannerEmitter = new Subject<{ type: string; error?: string }>();
    showBannerEvent$ = this.showBannerEmitter.asObservable();
    hideBannerEmitter = new Subject<{ type: string }>();
    hideBannerEvent$ = this.hideBannerEmitter.asObservable();

    constructor() {}

    showPopup(request: NotificationRequest): void {
        const messageCode = request.messageCode;
        if (messageCode && Object.hasOwn(NOTIFICATION_CATALOG, messageCode)) {
            const definition = NOTIFICATION_CATALOG[messageCode](request.context ?? {});
            this.showNotificationEmitter.next({ ...definition });
        } else {
            if (messageCode) {
                console.warn(`[ResponseErrorHandlerService] Unknown messageCode "${messageCode}". Falling back to defaultError.`);
            }
            const fallback = NOTIFICATION_CATALOG["defaultError"](request.context ?? {});
            this.showNotificationEmitter.next({ ...fallback });
        }
    }

    responseErrorHandler(error: HttpError | any, additionFlag?: any) {
        const params = {
            typeLayout: "ERROR",
        };
        if (error && error.status !== undefined) {
            switch (error.status) {
                case 409:
                    if (error.error && error.error.Message === "Unique field Email is already in table.") {
                        params["messageCode"] = "409ErrorUniqueEmail";

                        this.showPopup(params);
                        break;
                    }
                    params["messageCode"] = "defaultError";
                    this.showPopup(params);
                    break;
                case 429:
                    if (error.error && error.error.Message === "Too Many Requests") {
                        params["messageCode"] = "429TooManyRequests";
                        this.showPopup(params);
                        break;
                    }
                    params["messageCode"] = "defaultError";
                    this.showPopup(params);
                    break;
                case 500:
                    params["messageCode"] = "500Error";
                    this.showPopup(params);
                    break;

                default:
                    params["messageCode"] = "defaultError";
                    this.showPopup(params);
            }
            console.warn(JSON.stringify(error));
        } else {
            params["messageCode"] = "defaultError";
            this.showPopup(params);
        }
    }

    showBanner(data) {
        this.showBannerEmitter.next(data);
    }
}
